import { T } from 'react-translator-component';

import { parseNotificationMessageType } from './notificationMessageType';
import { normalizedNotification } from './notificationTimeline';

import { InnerDataFormater } from '../../components/organisms/AlertsTable/listFormater';

export const parseAlertDetailTimeline = (
  alertList: InnerDataFormater[],
  transactionId: number,
): normalizedNotification[] | any => {
  return alertList
    .filter(
      (alert) =>
        alert.about?.transactionId && alert.about.transactionId === transactionId && alert.about.type !== 'Warning',
    )
    .map((alert) => {
      return {
        type: alert.about.type,
        message: `${alert.about.chargeBoxName}: ${parseNotificationMessageType(alert.about.type)}. ${
          alert.about.userName ? `${T('User')}: ${alert.about.userName}` : ''
        }`,
        date: alert.about.dateTime,
      };
    });
};
